// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-height: calc(100vh - 476px);
}
.card-link:hover {
  background-color: #e1e1e1;
}

.detail-heading {
  font-weight: 600;
}

#viewSearchResult #advert-tile {
  text-decoration-line: none;
}

.mat-mdc-card-content:last-child {
    padding-bottom: 0px;
}

.mat-mdc-card-content:first-child {
    padding-top: 0px;
}

.mat-mdc-card-content {
    padding: 0px;
}

#viewSearchResult .mat-mdc-card.card-link {
  margin-bottom: 20px;
}

.col-md-9 h2 {
  padding: 10px;
}

.page-item .page-link {
  color: #72777c;
}

.no-result-msg {
  max-width: 50%;
}

.weg-btn {
  padding-right: 2rem;
  padding-left: 2rem;
}

.create-job-alert {
  z-index: 1019;
  width: 825px;
}

#goBackLink {
  color: var(--main-color);
  margin-left: -16px;
  margin-bottom: 10px;
}

#goBackLink:hover {
  color: var(--main-color);
  cursor: pointer;
}

@media screen and (min-width: 768px) {
  .date-detail {
    float: right;
  }
}

@media screen and (max-width: 767px) {
  .sfcontainer {
    padding: 20px 0;
  }

  .detail-heading {
    width: 100px;
  }
  .col-md-3,
  .col-md-9 {
    margin-top: -10px;
  }

  .no-result-msg {
    max-width: 100%;
  }

  .create-job-alert {
    position: fixed;
    z-index: 1019;
    width: 509px;
    top: 111px;
  }

  .logo-img {
    float: none;
  }

  .mat-mdc-card-title.no-margin {
    margin-top: 0;
  }
}

@media screen and (min-width: 375px) and (max-width: 500px) {
  .create-job-alert {
    z-index: 1019;
    width: 382px;
    top: 111px;
  }
}

@media screen and (max-width: 375px) {
  .create-job-alert {
    z-index: 1019;
    width: 343px;
    top: 111px;
  }
}

.logo-img > img {
  max-height: 100px;
  max-width: 160px;
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/search/search.result.component.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;EACA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".container {\r\n  min-height: calc(100vh - 476px);\r\n}\r\n.card-link:hover {\r\n  background-color: #e1e1e1;\r\n}\r\n\r\n.detail-heading {\r\n  font-weight: 600;\r\n}\r\n\r\n#viewSearchResult #advert-tile {\r\n  text-decoration-line: none;\r\n}\r\n\r\n.mat-mdc-card-content:last-child {\r\n    padding-bottom: 0px;\r\n}\r\n\r\n.mat-mdc-card-content:first-child {\r\n    padding-top: 0px;\r\n}\r\n\r\n.mat-mdc-card-content {\r\n    padding: 0px;\r\n}\r\n\r\n#viewSearchResult .mat-mdc-card.card-link {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.col-md-9 h2 {\r\n  padding: 10px;\r\n}\r\n\r\n.page-item .page-link {\r\n  color: #72777c;\r\n}\r\n\r\n.no-result-msg {\r\n  max-width: 50%;\r\n}\r\n\r\n.weg-btn {\r\n  padding-right: 2rem;\r\n  padding-left: 2rem;\r\n}\r\n\r\n.create-job-alert {\r\n  z-index: 1019;\r\n  width: 825px;\r\n}\r\n\r\n#goBackLink {\r\n  color: var(--main-color);\r\n  margin-left: -16px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n#goBackLink:hover {\r\n  color: var(--main-color);\r\n  cursor: pointer;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .date-detail {\r\n    float: right;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .sfcontainer {\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .detail-heading {\r\n    width: 100px;\r\n  }\r\n  .col-md-3,\r\n  .col-md-9 {\r\n    margin-top: -10px;\r\n  }\r\n\r\n  .no-result-msg {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .create-job-alert {\r\n    position: fixed;\r\n    z-index: 1019;\r\n    width: 509px;\r\n    top: 111px;\r\n  }\r\n\r\n  .logo-img {\r\n    float: none;\r\n  }\r\n\r\n  .mat-mdc-card-title.no-margin {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 375px) and (max-width: 500px) {\r\n  .create-job-alert {\r\n    z-index: 1019;\r\n    width: 382px;\r\n    top: 111px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 375px) {\r\n  .create-job-alert {\r\n    z-index: 1019;\r\n    width: 343px;\r\n    top: 111px;\r\n  }\r\n}\r\n\r\n.logo-img > img {\r\n  max-height: 100px;\r\n  max-width: 160px;\r\n  margin-right: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
